import { DefaultRole } from 'app/area/administration/shared/types';
import {
  UserWireData, AccessPerson, Person, AccessItem, ExtraInfoCodeValues
} from 'app/components/access-panel/shared/types';
import { Value } from 'app/types-shared';

export const ACTION = {
  REQUEST_LOAD_USER: 'ADMINISTRATION_EDIT_USER:REQUEST_LOAD_USER',
  RECEIVE_LOAD_USER: 'ADMINISTRATION_EDIT_USER:RECEIVE_LOAD_USER',
  FAIL_LOAD_USER: 'ADMINISTRATION_EDIT_USER:FAIL_LOAD_USER',
  REQUEST_LOAD_USER_ACCESS: 'ADMINISTRATION_EDIT_USER:REQUEST_LOAD_USER_ACCESS',
  RECEIVE_LOAD_USER_ACCESS: 'ADMINISTRATION_EDIT_USER:RECEIVE_LOAD_USER_ACCESS',
  FAIL_LOAD_USER_ACCESS: 'ADMINISTRATION_EDIT_USER:FAIL_LOAD_USER_ACCESS',
  REQUEST_ADD_USER: 'ADMINISTRATION_EDIT_USER:REQUEST_ADD_USER',
  RECEIVE_ADD_USER: 'ADMINISTRATION_EDIT_USER:RECEIVE_ADD_USER',
  REQUEST_UPDATE_USER: 'ADMINISTRATION_EDIT_USER:REQUEST_UPDATE_USER',
  RECEIVE_UPDATE_USER: 'ADMINISTRATION_EDIT_USER:RECEIVE_UPDATE_USER',
  FAIL_USER_EXECUTE: 'ADMINISTRATION_EDIT_USER:FAIL_USER_EXECUTE',
  CLEAR_SELECTED_CURRENT_USER_GROUP: 'ADMINISTRATION_EDIT_USER:CLEAR_SELECTED_CURRENT_USER_GROUP',
  CLEAR_VALIDATION: 'ADMINISTRATION_EDIT_ROLE:CLEAR_VALIDATION',
  CLEAR_USER_DATA: 'ADMINISTRATION_EDIT_USER:CLEAR_USER_DATA',
  PROCESS_USER_FAILED: 'ADMINISTRATION_EDIT_USER:PROCESS_USER_FAILED',
  REQUEST_CHANGE_USER_ID: 'ADMINISTRATION_EDIT_USER:REQUEST_CHANGE_USER_ID',
  RECEIVE_CHANGE_USER_ID: 'ADMINISTRATION_EDIT_USER:RECEIVE_CHANGE_USER_ID',
  FAIL_CHANGE_USER_ID: 'ADMINISTRATION_EDIT_USER:FAIL_CHANGE_USER_ID',
  REQUEST_EXTRA_INFO: 'ADMINISTRATION_EDIT_USER:REQUEST_EXTRA_INFO',
  RECEIVE_EXTRA_INFO: 'ADMINISTRATION_EDIT_USER:RECEIVE_EXTRA_INFO',
  FAIL_EXTRA_INFO: 'ADMINISTRATION_EDIT_USER:FAIL_EXTRA_INFO',
  REQUEST_PERSON_OPTIONS: 'ADMINISTRATION_EDIT_USER:REQUEST_PERSON_OPTIONS',
  RECEIVE_PERSON_OPTIONS: 'ADMINISTRATION_EDIT_USER:RECEIVE_PERSON_OPTIONS',
  FAIL_PERSON_OPTIONS: 'ADMINISTRATION_EDIT_USER:FAIL_PERSON_OPTIONS',
  REQUEST_ROLE: 'ADMINISTRATION_EDIT_USER:REQUEST_ROLE',
  RECEIVE_ROLE: 'ADMINISTRATION_EDIT_USER:RECEIVE_ROLE',
  FAIL_ROLE: 'ADMINISTRATION_EDIT_USER:FAIL_ROLE',
  UPDATE_ACCESS_DATA: 'ADMINISTRATION_EDIT_USER:UPDATE_ACCESS_DATA',
  REQUEST_ROLE_PANEL_ACCESS: 'ADMINISTRATION_EDIT_USER:REQUEST_ROLE_PANEL_ACCESS',
  RECEIVE_ROLE_PANEL_ACCESS: 'ADMINISTRATION_EDIT_USER:RECEIVE_ROLE_PANEL_ACCESS',
  FAIL_ROLE_PANEL_ACCESS: 'ADMINISTRATION_EDIT_USER:FAIL_ROLE_PANEL_ACCESS',
  REQUEST_CHANGE_DATABASE_ACCOUNT: 'ADMINISTRATION_EDIT_USER:REQUEST_CHANGE_DATABASE_ACCOUNT',
  RECEIVE_CHANGE_DATABASE_ACCOUNT: 'ADMINISTRATION_EDIT_USER:RECEIVE_CHANGE_DATABASE_ACCOUNT',
  FAIL_CHANGE_DATABASE_ACCOUNT: 'ADMINISTRATION_EDIT_USER:FAIL_CHANGE_DATABASE_ACCOUNT',
  REQUEST_DEFAULT_ROLE: 'ADMINISTRATION_EDIT_USER:REQUEST_DEFAULT_ROLE',
  RECEIVE_DEFAULT_ROLE: 'ADMINISTRATION_EDIT_USER:RECEIVE_DEFAULT_ROLE',
  FAIL_DEFAULT_ROLE: 'ADMINISTRATION_EDIT_USER:FAIL_DEFAULT_ROLE',

  SHOW_TECHNICAL_USER_WARNING: 'ADMINISTRATION_EDIT_USER:SHOW_TECHNICAL_USER_WARNING',
  HIDE_TECHNICAL_USER_WARNING: 'ADMINISTRATION_EDIT_USER:HIDE_TECHNICAL_USER_WARNING',

  REQUEST_CHECK_ROLES: 'ADMINISTRATION_EDIT_USER:REQUEST_CHECK_ROLES',
  RECEIVE_CHECK_ROLES: 'ADMINISTRATION_EDIT_USER:RECEIVE_CHECK_ROLES',
  FAIL_CHECK_ROLES: 'ADMINISTRATION_EDIT_USER:FAIL_CHECK_ROLES'
};

export class ClearValidation {

  public type: string = ACTION.CLEAR_VALIDATION;

  constructor(public formName: string,
    public parameters: { [key: string]: number | string }) {
  }
}

export class RequestLoadUser {
  public type: string = ACTION.REQUEST_LOAD_USER;
}

export class ReceiveLoadUser {
  public type: string = ACTION.RECEIVE_LOAD_USER;
  public data: UserWireData;

  constructor(data: UserWireData) {
    this.data = data;
  }
}

export class FailLoadUser {
  public type: string = ACTION.FAIL_LOAD_USER;
}

export class RequestLoadUserAccess {
  public type: string = ACTION.REQUEST_LOAD_USER_ACCESS;
}

export class ReceiveLoadUserAccess {
  public type: string = ACTION.RECEIVE_LOAD_USER_ACCESS;
  public accessPerson: AccessPerson;

  constructor(accessPerson: AccessPerson) {
    this.accessPerson = accessPerson;
  }
}

export class FailLoadUserAccess {
  public type: string = ACTION.FAIL_LOAD_USER_ACCESS;
}

export class RequestAddUser {
  public type: string = ACTION.REQUEST_ADD_USER;
}

export class ReceiveAddUser {
  public type: string = ACTION.RECEIVE_ADD_USER;
}

export class RequestUpdateUser {
  public type: string = ACTION.REQUEST_UPDATE_USER;
}

export class ReceiveUpdateUser {
  public type: string = ACTION.RECEIVE_UPDATE_USER;
}

export class FailUserExecute {
  public type: string = ACTION.FAIL_USER_EXECUTE;
}

export class ClearSelectedCurrentUserGroup {
  public type: string = ACTION.CLEAR_SELECTED_CURRENT_USER_GROUP;
}

export class ClearUserData {
  public type: string = ACTION.CLEAR_USER_DATA;
}

export class ProcessUserFailed {
  public type: string = ACTION.PROCESS_USER_FAILED;
  public validation: any;

  constructor(validation: any) {
    this.validation = validation;
  }
}

export class RequestChangePersonId {
  public type: string = ACTION.REQUEST_CHANGE_USER_ID;
}

export class ReceiveChangePersonId {
  public type: string = ACTION.RECEIVE_CHANGE_USER_ID;
  public personId: string;
  constructor(personId: string) {
    this.personId = personId;
  }
}

export class FailChangePersonId {
  public type: string = ACTION.FAIL_CHANGE_USER_ID;
}

export class RequestExtraInfo {
  public type: string = ACTION.REQUEST_EXTRA_INFO;
}

export class ReceiveExtraInfo {
  public type: string = ACTION.RECEIVE_EXTRA_INFO;
  constructor(public values: ExtraInfoCodeValues[]) { }
}

export class FailExtraInfo {
  public type: string = ACTION.FAIL_EXTRA_INFO;
}

export class RequestPersonOptions {
  public type: string = ACTION.REQUEST_PERSON_OPTIONS;
}

export class ReceivePersonOptions {
  public type: string = ACTION.RECEIVE_PERSON_OPTIONS;
  constructor(public values: Value[]) { }
}

export class FailPersonOptions {
  public type: string = ACTION.FAIL_PERSON_OPTIONS;
}

export class RequestRole {
  public type: string = ACTION.REQUEST_ROLE;
  constructor(public id: number) {
  }
}

export class ReceiveRole {
  public type: string = ACTION.RECEIVE_ROLE;
  constructor(public id: number, public data: Person) {
  }
}

export class FailRole {
  public type: string = ACTION.FAIL_ROLE;
  constructor(public id: number) {
  }
}

export class UpdateAccessData {
  public type: string = ACTION.UPDATE_ACCESS_DATA;
  public key: string;
  public accessItem: Partial<AccessItem>;

  constructor(key: string, accessItem: Partial<AccessItem>) {
    this.key = key;
    this.accessItem = accessItem;
  }
}

export class RequestRolePanelAccess {
  public type: string = ACTION.REQUEST_ROLE_PANEL_ACCESS;
}

export class ReceiveRolePanelAccess {
  public type: string = ACTION.RECEIVE_ROLE_PANEL_ACCESS;
  constructor(public values: Value[]) { }
}

export class FailRolePanelAccess {
  public type: string = ACTION.FAIL_ROLE_PANEL_ACCESS;
}

export class RequestChangeDatabaseAccount {
  public type: string = ACTION.REQUEST_CHANGE_DATABASE_ACCOUNT;
}

export class ReceiveChangeDatabaseAccount {
  public type: string = ACTION.RECEIVE_CHANGE_DATABASE_ACCOUNT;
}

export class FailChangeDatabaseAccount {
  public type: string = ACTION.FAIL_CHANGE_DATABASE_ACCOUNT;
}

export class RequestDefaultRole {
  public type: string = ACTION.REQUEST_DEFAULT_ROLE;
}

export class ReceiveDefaultRole {
  public type: string = ACTION.RECEIVE_DEFAULT_ROLE;
  constructor(public defaultRole: DefaultRole) { }
}

export class FailDefaultRole {
  public type: string = ACTION.FAIL_DEFAULT_ROLE;
}

export class ShowTechnicalUserWarning {
  public type: string = ACTION.SHOW_TECHNICAL_USER_WARNING;
}

export class HideTechnicalUserWarning {
  public type: string = ACTION.HIDE_TECHNICAL_USER_WARNING;
}

export class RequestCheckRoles {
  public type: string = ACTION.REQUEST_CHECK_ROLES;
}

export class ReceiveCheckRoles {
  public type: string = ACTION.RECEIVE_CHECK_ROLES;
  constructor(public hasRoles: boolean) { }
}

export class FailCheckRoles {
  public type: string = ACTION.FAIL_CHECK_ROLES;
}
